<template>
  <q-chip class="count-chip"
          v-bind="$attrs">
    <slot>{{ count }}</slot>
  </q-chip>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
    },
  },
}
</script>
